import React from 'react';
import { volumes } from '../data/content';
export function WhatsIncluded() {
  return <section id="included" className="w-full bg-slate-100 px-5 py-12 sm:py-16" data-id="element-197" data-mp="bvd0pmx0ccig">
      <div className="mx-auto max-w-[960px]" data-id="element-198" data-mp="3u9m6s0apwp6w">
        <h2 className="sr-only" data-id="element-199" data-mp="3uanlqfuutvtw">The 6 volumes included in ANATOMY READY™</h2>

        <ol className="grid gap-3 md:grid-cols-2" data-id="element-200" data-mp="25bllkmmu4fo">
          {volumes.map(volume => <li key={volume.label} className="flex flex-col rounded-lg border border-slate-200 bg-white p-5" style={{
          borderLeft: `5px solid ${volume.color}`
        }} data-id="element-201" data-mp="pvnscs655v4o">
              <p className="text-[0.75rem] font-black uppercase tracking-[0.18em]" style={{
            color: volume.color
          }} data-id="element-202" data-mp="gvix1ge82n6v">
                {volume.label}
              </p>
              <h3 className="mt-1 text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 sm:text-[1.1rem]" data-id="element-203" data-mp="31k5hhbie9oew">
                {volume.title}
              </h3>
              <p className="mt-2 text-[0.95rem] leading-relaxed text-slate-800" data-id="element-204" data-mp="1wgvwke3njm0i">
                {volume.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}